import type { QueryClient, QueryKey } from "@tanstack/react-query";
import { subscribeToSseInvalidation } from "./sse-invalidation";

/** Sidebar and settings share one connection. Polling remains the fallback. */
export function subscribeToDataStatus(
  client: QueryClient,
  workspaceId: string,
  queryKey: QueryKey,
  onConnectionChange?: (state: "open" | "error") => void,
) {
  return subscribeToSseInvalidation(client, {
    id: `data-status:${workspaceId}`,
    url: `/api/v1/sync/data-status/events?workspaceId=${encodeURIComponent(workspaceId)}`,
    eventNames: ["data.changed"],
    queryKey,
    onConnectionChange,
  });
}

/** Refresh an open Product Center when the shared status snapshot is refreshed. */
export function subscribeProductCenterRefresh(client: QueryClient, workspaceId: string) {
  return client.getQueryCache().subscribe((event) => {
    if (event.type !== "updated" || event.action.type !== "success") return;
    const key = event.query.queryKey;
    if (key.length !== 3 || key[0] !== "sync" || key[1] !== "data-status" || key[2] !== workspaceId)
      return;
    void client.invalidateQueries({ queryKey: ["product-center"], type: "active" });
  });
}
